var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    y: 341.33,
    style: {
      fill: "#41479B"
    },
    width: 512,
    height: 170.67
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FF4B55"
    },
    width: 512,
    height: 170.67
  }), /*#__PURE__*/React.createElement("rect", {
    y: 170.67,
    style: {
      fill: "#F5F5F5"
    },
    width: 512,
    height: 170.67
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 161.68,
    y: 175.16,
    style: {
      fill: "#FF4B55"
    },
    width: 37.726,
    height: 43.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.14,
    y: 175.16,
    style: {
      fill: "#FF4B55"
    },
    width: 37.726,
    height: 43.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.41,
    y: 218.27,
    style: {
      fill: "#FF4B55"
    },
    width: 37.726,
    height: 43.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.59,
    y: 175.16,
    style: {
      fill: "#FF4B55"
    },
    width: 37.726,
    height: 43.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.86,
    y: 218.27,
    style: {
      fill: "#FF4B55"
    },
    width: 37.726,
    height: 43.12
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 199.41,
    y: 175.16,
    style: {
      fill: "#F5F5F5"
    },
    width: 37.726,
    height: 43.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.86,
    y: 175.16,
    style: {
      fill: "#F5F5F5"
    },
    width: 37.726,
    height: 43.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.68,
    y: 218.27,
    style: {
      fill: "#F5F5F5"
    },
    width: 37.726,
    height: 43.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.14,
    y: 218.27,
    style: {
      fill: "#F5F5F5"
    },
    width: 37.726,
    height: 43.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.59,
    y: 218.27,
    style: {
      fill: "#F5F5F5"
    },
    width: 37.726,
    height: 43.12
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 237.14,
    y: 261.39,
    style: {
      fill: "#FF4B55"
    },
    width: 37.726,
    height: 43.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.41,
    y: 304.5,
    style: {
      fill: "#FF4B55"
    },
    width: 37.726,
    height: 43.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.86,
    y: 304.5,
    style: {
      fill: "#FF4B55"
    },
    width: 37.726,
    height: 43.12
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 199.41,
    y: 261.39,
    style: {
      fill: "#F5F5F5"
    },
    width: 37.726,
    height: 43.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.86,
    y: 261.39,
    style: {
      fill: "#F5F5F5"
    },
    width: 37.726,
    height: 43.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.14,
    y: 304.5,
    style: {
      fill: "#F5F5F5"
    },
    width: 37.726,
    height: 43.12
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M350.316,175.158v121.263c0,52.089-42.227,94.316-94.316,94.316s-94.316-42.227-94.316-94.316   V175.158H350.316 M357.053,168.421h-6.737H161.684h-6.737v6.737v121.263c0,55.72,45.332,101.053,101.053,101.053   s101.053-45.332,101.053-101.053V175.158V168.421L357.053,168.421z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M199.41,304.505v-43.116h-37.726v35.032c0,2.729,0.181,5.414,0.408,8.084H199.41z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M349.908,304.505H312.59v43.116h22.549C343.322,334.999,348.563,320.319,349.908,304.505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M176.861,347.621h22.549v-43.116h-37.318C163.438,320.319,168.678,334.999,176.861,347.621z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M312.59,304.505h37.318c0.227-2.67,0.408-5.354,0.408-8.084v-35.032H312.59V304.505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M199.41,371.745v-24.124h-22.549C182.903,356.941,190.556,365.082,199.41,371.745z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M335.139,347.621H312.59v24.124C321.444,365.082,329.097,356.941,335.139,347.621z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M199.41,371.745c10.981,8.264,23.761,14.263,37.726,17.098v-41.222H199.41V371.745z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M274.863,388.843c13.965-2.835,26.745-8.834,37.726-17.098v-24.124h-37.726V388.843z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M274.863,347.621h-37.727v41.222c6.095,1.238,12.403,1.894,18.863,1.894  c6.461,0,12.768-0.656,18.863-1.894v-41.222L274.863,347.621L274.863,347.621z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4173CD"
    },
    d: "M187.729,103.813c-8.208-1.27-16.607-2.186-25.167-2.715c-6.621,5.451-12.933,11.133-18.924,17.018   c6.016,14.522,12.031,29.045,18.046,43.568c12.078-5.002,24.454-9.005,37.009-12.007   C195.039,134.389,191.383,119.101,187.729,103.813z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4173CD"
    },
    d: "M278.899,96.66c-7.376-3.732-15.015-7.183-22.899-10.326c-7.884,3.144-15.523,6.595-22.899,10.326   c1.226,15.67,2.452,31.341,3.678,47.014c12.794-1.002,25.648-1.002,38.442,0C276.447,128.003,277.673,112.332,278.899,96.66z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4173CD"
    },
    d: "M368.362,118.116c-5.991-5.885-12.303-11.567-18.924-17.018c-8.56,0.53-16.958,1.446-25.167,2.715   c-3.655,15.289-7.31,30.576-10.965,45.865c12.556,3.002,24.931,7.004,37.009,12.007   C356.331,147.161,362.347,132.638,368.362,118.116z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M233.101,96.66c-7.866-2.538-15.96-4.76-24.26-6.635c-7.322,4.336-14.364,8.942-21.112,13.787   c3.655,15.289,7.31,30.576,10.965,45.865c12.556-3.002,25.29-5.002,38.085-6.003C235.553,128.003,234.327,112.332,233.101,96.66z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M324.271,103.813c-6.749-4.846-13.791-9.451-21.112-13.787c-8.3,1.875-16.393,4.097-24.26,6.635   c-1.226,15.67-2.452,31.341-3.678,47.014c12.794,1.001,25.53,3.001,38.085,6.003C316.961,134.389,320.617,119.101,324.271,103.813z   "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M234.572,115.466c-14.263,1.115-28.461,3.345-42.457,6.692c-0.731-3.058-1.462-6.115-2.193-9.174   c14.477-3.46,29.161-5.767,43.914-6.922C234.082,109.198,234.327,112.331,234.572,115.466z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M236.043,134.271c-13.284,1.039-26.506,3.117-39.542,6.233c-0.732-3.057-1.462-6.116-2.193-9.173   c13.516-3.232,27.226-5.387,41-6.463C235.553,128.002,235.798,131.138,236.043,134.271z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M300.762,137.437c-3.289-0.585-6.588-1.104-9.893-1.559c-5.436-0.751-9.485-5.366-9.014-10.555l0,0  c0.47-5.185,5.668-8.948,11.585-8.132c3.548,0.488,7.09,1.046,10.622,1.674c5.889,1.04,9.703,6.229,8.554,11.305l0,0  C311.468,135.254,306.177,138.391,300.762,137.437z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M353.925,152.97c-12.539-5.193-25.391-9.35-38.426-12.466c0.732-3.057,1.462-6.116,2.193-9.173  c13.516,3.23,26.84,7.539,39.842,12.925C356.332,147.161,355.128,150.066,353.925,152.97z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M350.559,124.674c-1.333,3.674-5.826,5.422-10.072,4.041c-4.245-1.382-6.843-5.419-5.768-9.176   c1.075-3.757,5.625-5.746,10.13-4.283C349.354,116.717,351.892,121.002,350.559,124.674z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M177.281,119.539c1.074,3.762-1.527,7.798-5.768,9.176c-4.244,1.375-8.738-0.373-10.072-4.041   c-1.335-3.674,1.206-7.957,5.711-9.418C171.653,113.798,176.209,115.785,177.281,119.539z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M253.848,113.364c0.009,3.125-2.8,5.669-6.279,5.775c-3.478,0.112-6.444-2.26-6.627-5.373   c-0.182-3.114,2.625-5.808,6.275-5.927C250.868,107.725,253.834,110.239,253.848,113.364z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M271.058,113.766c-0.186,3.118-3.151,5.484-6.627,5.373c-3.478-0.107-6.288-2.651-6.279-5.775   c0.013-3.121,2.98-5.642,6.631-5.525C268.435,107.95,271.238,110.65,271.058,113.766z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M262.117,127.911c-0.087,3.125-2.825,5.582-6.117,5.581c-3.292-0.002-6.028-2.456-6.117-5.581   c-0.085-3.115,2.651-5.732,6.117-5.724C259.466,122.181,262.203,124.794,262.117,127.911z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHr);
export default __webpack_public_path__ + "static/media/hr.145be2b69008bf3b3576aaf8b1208e11.svg";
export { ForwardRef as ReactComponent };